import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import { bookingStatuses } from '../constants';
import Guest, { IGuest } from './guest';
import Period, { IPeriod } from './period';
import ServiceOptionsField, { IServiceOptions } from './service-options';

export interface IReservation {
  _id: ObjectID;
  startDate: Date;
  endDate: Date;
  bookingStatus: string;
  bookingId: string;
  user: ObjectID;
  serviceGroup: ObjectID;
  serviceOrganizationIds: ObjectID[];
  service: ObjectID;
  source: ObjectID;
  period?: IPeriod;
  price: number;
  guests: IGuest[];
  serviceOption?: IServiceOptions;
  paymentTransaction: ObjectID;
  updatedAt: Date;
  createdAt: Date;
}
export interface IReservationDocument extends mongoose.Document, IReservation {
  _id: ObjectID;
}

const reservation = new Schema(
  {
    // the date on which the service is scheduled
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
    bookingStatus: {
      type: String,
      enum: Object.values(bookingStatuses),
      default: bookingStatuses.booked,
      required: true,
    },
    bookingId: {
      type: String,
      required: true,
    },
    user: {
      type: Schema.Types.ObjectId,
      ref: 'User',
      required: true,
    },
    serviceGroup: {
      type: Schema.Types.ObjectId,
      ref: 'ServiceGroup',
      required: true,
    },
    serviceOrganizationIds: {
      type: [Schema.Types.ObjectId],
      required: true,
    },
    service: {
      type: Schema.Types.ObjectId,
      ref: 'Service',
      required: true,
    },
    source: {
      type: Schema.Types.ObjectId,
      ref: 'Source',
      required: true,
    },
    period: {
      type: Period,
      required: false,
    },
    price: {
      type: Number,
      required: true,
    },
    guests: {
      type: [Guest],
      required: true,
      validate: {
        validator(array: IGuest[]) {
          return array.length >= 1;
        },
      },
    },
    serviceOption: {
      type: ServiceOptionsField,
    },
    paymentTransaction: {
      type: Schema.Types.ObjectId,
      ref: 'PaymentTransaction',
      required: true,
    },
  },
  { timestamps: true },
);

export default reservation;
